import { CoreProxyService, AppService, CoreTypes, FormValidatorService, CommonCloudstudioService, LabelValue } from "common-cloudstudio";
import { GearProxyService, GearAppService, GearTypes } from "common-gear";
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import { NgForm } from "@angular/forms";
import { Router } from "@angular/router";
import { DashboardWidgetsEditService } from "./dashboard/dashboard-element-modal/dashboard-widgets-edit/dashboard-widgets-edit.service";

@Component({
  selector: 'app-dashboards',
  templateUrl: './dashboards.component.html',
  styleUrls: ['./dashboards.component.scss']
})
export class DashboardsComponent implements OnInit, OnDestroy {
  @ViewChild('confirmRemove') private _confirmRemove: any;
  @ViewChild('modalCloneDashboard') private _modalCloneDashboard: any;
  @ViewChild('formElement') private _formElement: NgForm;

  _caption: string = "";
  _errorBackEnd: string = "";
  _errorMessage: string;
  _masterDataEntityContent: CoreTypes.MasterEntityDataContent;
  _facilityId: number = 0;
  subscriptions: Subscription[] = [];
  _rowIDToDelete: number;
  _description: string;
  _dashboardId: number;
  _parameters: CoreTypes.Dashboard = null;
  _pageStatus = 0;
  goBackRoute: string = 'dashboard'
  cloneParams = {
    description: '',
    dashboardId: 0,
    cloneDestination: new LabelValue<number>(),
    clonePermissions: false
  };
  cloneDestinationsList: LabelValue<number>[] = [
    { label: this._appService.CoreCommonLiterals?.CloneGlobalDashboard, value: 0 },
    { label: this._appService.CoreCommonLiterals?.CloneClientDashboard, value: 1 },
  ];


  constructor(
    public _appService: AppService,
    private _gearProxyService: GearProxyService,
    public _gearAppService: GearAppService,
    public _appProxyService: CoreProxyService,
    public formValidatorService: FormValidatorService,
    private commonService: CommonCloudstudioService,
    private router: Router,
    private dashboardWidgetsEditService: DashboardWidgetsEditService
  ) {}

  ngOnInit() {
    this.getData();
    this._facilityId = this._appService.getFacilityID();
    this.subscriptions.push(this._gearAppService.onChangeFacilityID.subscribe(facilityId => {
      if (this._facilityId == facilityId) { return; }
      this._facilityId = this._appService.getFacilityID();
    }));

    this.subscriptions.push(this._appService.onFacilitySet.subscribe(() => {
      if (this._facilityId && this._facilityId !== this._appService.getFacilityID()) { this.getData(); }
    }));

  }

  ngOnDestroy(){
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  goBack(link, id?) {
    id ? this.router.navigate([link, id]) : this.router.navigate([link, 0]);
  }

  getData() {
    this._pageStatus = 0;
    this._masterDataEntityContent = null;

    this._gearProxyService.MasterEntityService.GetMasterEntityContent(
      this._appService.getAccessToken(),
      this._appService.getClientID(),
      this._appService.getFacilityID(),
      GearTypes.GearMasterEntityType.Dashboards_Unified,
      (success) => {
        this._masterDataEntityContent = success;
        this._pageStatus = 1;
      },
      (err) => {
        this._pageStatus = 2;
        this._appService.showException(err);
      }
    );
  }

  confirmOnRemove(rowIDToDelete) {
    this._rowIDToDelete = rowIDToDelete;
    this._confirmRemove.open();
  }

  onConfirmRemove() {
    this._appProxyService.DashboardService.DeleteDashboard(
      this._appService.getAccessToken(),
      this._rowIDToDelete,
      () => {
        this._confirmRemove.close();
        this.commonService.dashboards.length = 0;
        this.commonService._dashboardStatus = 0;
        this.dashboardWidgetsEditService._dashboardFullList.value.length = 0;
        this.dashboardWidgetsEditService._dashboardStatus = 0;
        this.getData();
      },
      (err) => {
        this._errorMessage = err.Message;
      }
    );
  }

  async cloneDashboard(dashboardId) {
    this._dashboardId = dashboardId;
    await this.getDashboard();
    this.cloneParams.dashboardId = dashboardId;
    this.cloneParams.cloneDestination = this.cloneDestinationsList[0];
    this._modalCloneDashboard.open();
  }

  saveDashboard(formElement) {
    if( formElement.form.invalid) {
      const getErrorMessage = this.formValidatorService.getValidationErrors(formElement);
      this._errorMessage = getErrorMessage;
      return;
    }
    this._pageStatus = 0;
    if (this._parameters.ClientID === 0) {
      this.cloneParams.description = this._description;
      const clientId = (this.cloneParams.cloneDestination.value === 1) ? this._appService.getClientID() : 0;
      this._appProxyService.DashboardService.CloneDashboards(
        this._appService.getAccessToken(),
        this._appService.getFacilityID(),
        this.cloneParams.dashboardId,
        this.cloneParams.description,
        clientId,
        this.cloneParams.clonePermissions,
        () => {
          this._pageStatus = 1; 
          // Reset params
          this._description = '';
          this.cloneParams = {
            description: '',
            dashboardId: 0,
            cloneDestination: new LabelValue<number>(),
            clonePermissions: false
          };
          this.getData();
          this._modalCloneDashboard.close();
        },
        err => {
          this._errorMessage = err.Message;
          this._pageStatus = 2;
        }
      );
    } else if(this._parameters.ClientID) {
      this._parameters.Description = this._description;
      this._parameters.DashboardID = 0;
      this._appProxyService.DashboardService.CreateClientDashboard(
        this._appService.getAccessToken(),
        this._appService.getClientID(),
        this._appService.getFacilityID(),
        this._parameters,
        success => {
          this._pageStatus = 1;
          this._description = '';
          this.commonService.dashboards.length = 0;
          this.commonService._dashboardStatus = 0;
          this.getData();
          this._modalCloneDashboard.close();
        },
        (err) => {
          this._pageStatus = 2;
          this._errorMessage = err.Message;
        }
      );
    }
  }

  getDashboard() {
    return new Promise((resolve, reject) => {
      this._appService.startLoading();
      this._appProxyService.DashboardService.GetDashboard(
        this._appService.getAccessToken(),
        this._dashboardId,
        data => {
          this._parameters = data;
          this._pageStatus = 1;
          resolve(data);
          this._appService.stopLoading();
        },
        (err) => {
          this._pageStatus = 2;
          reject(err);
          this._appService.showException(err);
          this._appService.stopLoading();
          this._errorMessage = err.Message;
        }
      )
    })
  }
}
